import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { beginLoginRedirect, isAuthenticated } from '../auth/oidc';

const routes: RouteRecordRaw[] = [
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: () => import('@/views/AuthCallbackView.vue'),
    meta: { skipAuth: true },
  },
  {
    path: '/auth/logout-callback',
    name: 'AuthLogoutCallback',
    component: () => import('@/views/AuthLogoutCallbackView.vue'),
    meta: { skipAuth: true },
  },
  {
    path: '/',
    redirect: '/meta-accounts',
  },
  {
    path: '/health',
    name: 'Health',
    component: () => import('@/views/HealthView.vue'),
  },
  {
    path: '/brands',
    name: 'Brands',
    component: () => import('@/views/BrandsView.vue'),
  },
  {
    path: '/llm-test',
    name: 'LLMTest',
    component: () => import('@/views/LLMTestView.vue'),
  },
  {
    path: '/strategy-management',
    name: 'StrategyManagement',
    component: () => import('@/views/StrategyManagementView.vue'),
  },
  {
    path: '/content-calendar',
    name: 'ContentCalendar',
    component: () => import('@/views/ContentCalendarView.vue'),
  },
  {
    path: '/content-calendar/:customerId',
    name: 'ContentCalendarCustomer',
    component: () => import('@/views/ContentCalendarView.vue'),
  },
  {
    path: '/media-management',
    name: 'MediaManagement',
    component: () => import('@/views/MediaManagementView.vue'),
  },
  {
    path: '/media-management/:customerId',
    name: 'MediaManagementCustomer',
    component: () => import('@/views/MediaManagementView.vue'),
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('@/views/JobsView.vue'),
  },
  {
    path: '/meta-accounts',
    name: 'MetaAccounts',
    component: () => import('@/views/MetaAccountsView.vue'),
  },
  {
    path: '/meta-campaign-launch',
    name: 'MetaCampaignLaunch',
    component: () => import('@/views/CampaignLaunchView.vue'),
  },
  {
    path: '/meta-campaign-editor',
    name: 'MetaCampaignEditor',
    component: () => import('@/views/CampaignEditorView.vue'),
  },
  {
    path: '/meta-campaign-editor/:campaignId',
    name: 'MetaCampaignEditorDetail',
    component: () => import('@/views/CampaignEditorDetailView.vue'),
  },
  {
    path: '/advertiser-budgets',
    name: 'AdvertiserBudgets',
    component: () => import('@/views/AdvertiserBudgetsView.vue'),
  },
  {
    path: '/budget-invoicing',
    redirect: '/campaign-spend',
  },
  {
    path: '/campaign-spend',
    name: 'CampaignSpend',
    component: () => import('@/views/BudgetInvoicingView.vue'),
  },
  {
    path: '/candidate-resumes',
    name: 'CandidateResumes',
    component: () => import('@/views/CandidateResumesView.vue'),
  },
  {
    path: '/leads',
    name: 'Leads',
    component: () => import('@/views/LeadsView.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  if (to.meta.skipAuth) {
    return true;
  }

  const authenticated = await isAuthenticated();
  if (authenticated) {
    return true;
  }

  await beginLoginRedirect(to.fullPath);
  return false;
});

export default router;
